import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import DesktopView from './DesktopView';
import MobileView from './MobileView';

class RadioField extends PureComponent {
  static defaultProps = {
    className: '',
    isPhone: false,
    checked: false,
    disabled: false,
    description: '',
  };

  static propTypes = {
    className: PropTypes.string,
    isPhone: PropTypes.bool,
    children: PropTypes.any,
    inputRef: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    description: PropTypes.string,
  };

  render() {
    const {
      className,
      children,
      dispatch,
      description,
      label,
      isPhone,
      name,
      inputRef,
      ...otherProps
    } = this.props;

    const inputProps = {
      ...otherProps,
      ref: inputRef,
      type: 'radio',
      name,
    };

    const View = isPhone ? MobileView : DesktopView;

    return (
      <View
        {...this.props}
        className={className}
        children={children}
        inputProps={inputProps}
        label={label}
        description={description}
      />
    );
  }
}

const connector = connect(
  state => ({
    isPhone: state.responsive.isPhone || false,
  }),
  null,
);

export default connector(RadioField);
